import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';

@Injectable({
    providedIn: 'root'
})
export class UserpermissionsGatewayService {
    constructor(
        private http: HttpClient,
        private appConfig: AppConfigService,
    ) { }
    private apiURL = this.appConfig.getConfig().userpermissions_api_url;

    get<T>(url: string, params: HttpParams = new HttpParams()): Observable<T> {
        return this.http.get<T>(this.apiURL + `${url}`);
    }
}
